export default __webpack_public_path__ + "static/media/grey.f3bedca8.svg";